/* LEMEIN - crossfade the COLLECTION CARD image when a colour swatch is picked.

   Cards reuse the SAME <img> and swap its src, so there is no outgoing element to fade.
   Take the old URL from the MutationRecord (attributeOldValue), float a ghost of it over the
   card, and dissolve that once the new image has decoded. */
(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var FADE_MS = 380;

  function laidOut(el) {
    if (!el) return false;
    var box = el.getBoundingClientRect();
    if (box.width < 8 || box.height < 8) return false;
    return window.getComputedStyle(el).display !== "none";
  }

  /* Which of the two card images is the one on screen?

     Do NOT test computed opacity - the theme fades the image to 0 BEFORE it swaps src, so an
     opacity test races that transition and silently misses every swap after the first.

     Do NOT trust :hover alone either - on touch it can stick after a tap, and on mobile the
     secondary image is display:none, so we would pick a zero-size element and drop the fade.
     Require the secondary to be genuinely laid out before preferring it. */
  function isTheVisibleOne(img, card) {
    if (!card) return true;
    var secondary = card.querySelector(".product-card__image--secondary");
    var hovered = card.matches(":hover") && laidOut(secondary);
    var wanted = hovered ? secondary : card.querySelector(".product-card__image--primary");
    return img === wanted;
  }

  function ghostFor(img, oldSrc) {
    var rect = img.getBoundingClientRect();
    if (rect.width < 8 || rect.height < 8) return;
    if (rect.bottom < 0 || rect.top > window.innerHeight) return;

    var ghost = document.createElement("img");
    ghost.className = "lm-xfade";
    ghost.src = oldSrc;
    ghost.alt = "";
    ghost.setAttribute("aria-hidden", "true");
    ghost.style.left = rect.left + "px";
    ghost.style.top = rect.top + "px";
    ghost.style.width = rect.width + "px";
    ghost.style.height = rect.height + "px";
    document.body.appendChild(ghost);

    var started = false;
    var start = function () {
      if (started) return;
      started = true;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { ghost.classList.add("is-out"); });
      });
      setTimeout(function () {
        if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      }, FADE_MS + 140);
    };

    if (img.complete && img.naturalWidth > 0) {
      start();
    } else {
      img.addEventListener("load", start, { once: true });
      setTimeout(start, 900);
    }
  }

  var observer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var rec = records[i];
      if (rec.attributeName !== "src") continue;

      var img = rec.target;
      if (!img.classList) continue;
      if (!img.classList.contains("product-card__image")) continue;

      var card = img.closest ? img.closest("product-card") : null;
      if (!isTheVisibleOne(img, card)) continue;

      var oldSrc = rec.oldValue;
      if (!oldSrc) continue;
      if (oldSrc === img.getAttribute("src")) continue;

      ghostFor(img, oldSrc);
    }
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["src"],
    attributeOldValue: true,
    subtree: true
  });

  /* hold a hard reference - an unreferenced MutationObserver can be collected */
  window.__lmCardSwapObserver = observer;
})();
